<template lang="pug">
#PageResultRecentLocation
    //- Header Global
    HeaderGlobal(HeaderGlobalHeading="Recent Location" :HeaderGlobalBreadcrumb="breadcrumb")

    //- banner filter
    ResultFilter(v-if="isAstro !== 'true'")
    //- end banner filter

    //- Recent Location 
    OverAllRecentLocationAstro(:isKey="isKey")
    //- end Recent Location 
    
    OverAllLogRecentLocationAstro(v-if="isAstro === 'true' && route_name === 'target-detail-recent-location'" :isKey="isKey")

</template>

<script>

// overall's section
import HeaderGlobal from './../../components/HeaderGlobal.vue'
import ResultFilter from './../result/ResultFilter.vue'
import OverAllRecentLocationAstro from './../result/overall/RecentLocationAstro.vue'
import OverAllLogRecentLocationAstro from './../result/overall/LogRecentLocationAstro.vue'

export default {
    name: 'Overall',
    components: {
        HeaderGlobal,
        ResultFilter,
        OverAllRecentLocationAstro,
        OverAllLogRecentLocationAstro,
    },
    props: ['resultGlobalBreadcrumb'],
    data: function() {
        return {
            breadcrumb: [
                this.resultGlobalBreadcrumb,
                {
                    name: 'Recent Location',
                    url: '/result/recent-location',
                },
            ],
            isAstro: process.env.VUE_APP_ASTRO,
        };
    },
    computed: {
        key() {
            return this.$route.params.key;
        },
        isKey() {
            return this.key ? true : false;
        },
        route_name() {
            return this.$route.name;
        },
    },
    watch: {
        key() {},
        isKey() {},
        route_name() {},
    },
    mounted() {
        // console.log(this.route_name)
        // if (!this.isKey) {
        //     this.$store.dispatch('setEmptyResultData');
        // }
        // console.log('============== on RecentLocation.vue')
        // console.log(this.isKey)
        // console.log(this.resultGlobalBreadcrumb)
    }
}
</script>

<style lang="sass">
</style>
